import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, EMPTY } from 'rxjs';
import { ApiService } from '../services/api.service';
import { MetadataStandards } from '../models/metadata-standards.model';
import { NavigationService } from '../services/navigation.service';

export const metadataStandardsResolver: ResolveFn<MetadataStandards[]> = () => {
  const apiService = inject(ApiService);
  const navigationService = inject(NavigationService)

  return apiService.fetchMetadataStandardsContent().pipe(
    catchError((error) => {
    navigationService.handleResolverError(error);
      return EMPTY;
    })
  );
};
